import { Button, LoadingButton } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledNoComparison = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));

export const StyledButtons = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const CompareButton = styled(Button)(({ theme }) => ({
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
}));

export const InsightButton = styled(Button)(({ theme }) => ({
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
}));

export const DownloadButton = styled(LoadingButton)(({ theme }) => ({
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
}));
